// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__1sk6n","title":"Login_title__2HzUd","error":"Login_error__2M646","submit":"Login_submit__2ZwD2"};